<template>
  <div>
    <FieldLabel v-if="prop.show" :label="item.name" :help="showFieldHelp ? fieldHelp : null" :field-id="item.id" :modal-key="modalKey" />
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      min-width="320"
      :nudge-width="260"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="translateResult"
          @click:append="menu = true"
          v-bind="attrs"
          readonly
          v-on="on"
          :rules="prop.modelRules"
          v-if="prop.show"
          :outlined="prop.outlined"
          :filled="prop.filled"
          :solo="prop.solo"
          :hint="prop.description"
          :persistent-hint="prop.persistenthint"
          :disabled="prop.disabled"
          :class="prop.class"
          :clearable="prop.clearable"
          :color="prop.coloronselect"
          @click:clear="clearSelection()"
          :prepend-icon="
            prop.iconlr == 'prepend' && prop.iconinout == 'out'
              ? prop.iconmdi
              : ''
          "
          :prepend-inner-icon="
            prop.iconlr == 'prepend' && prop.iconinout != 'out'
              ? prop.iconmdi
              : ''
          "
          :append-icon="
            prop.iconlr == 'append' && prop.iconinout != 'out'
              ? prop.iconmdi
              : ''
          "
          :append-outer-icon="
            prop.iconlr == 'append' && prop.iconinout == 'out'
              ? prop.iconmdi
              : ''
          "
        ></v-text-field>
      </template>
      <v-card>
        <v-card-text class="pb-0">
          <v-date-picker
            v-model="selectedDate"
            locale="fr"
            no-title
            scrollable
            @input="updatePreview"
          />
          <div class="time-select mt-4">
            <div class="time-select__label">Heure</div>
            <div class="time-select__list" ref="timeList">
              <v-list dense class="pa-0">
                <v-list-item
                  v-for="time in timeOptions"
                  :key="time.value"
                  :class="[
                    'time-select__item',
                    time.value === highlightedTime
                      ? 'time-select__item--active'
                      : '',
                  ]"
                  @click="selectTime(time.value)"
                >
                  <v-list-item-title>{{ time.text }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </div>
          </div>
          </v-card-text>
        <v-card-actions>
          <v-btn text color="secondary" @click="cancel">Annuler</v-btn>
          <v-spacer />
          <v-btn text color="primary" @click="set">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import mixinFields from '../../mixins/Fields';
import mixinConditionsFields from '../../mixins/conditionsFields';

export default {
  name: 'dateTimeSelect',
  mixins: [mixinFields, mixinConditionsFields],
  data() {
    return {
      menu: false,
      translateResult: '',
      selectedDate: null,
      selectedTime: null,
      pendingValue: null,
      initialSnapshot: { date: null, time: null },
      customTimeOption: null,
      highlightedTime: '12:00',
    };
  },
  computed: {
    timeOptions() {
      const options = [];
      for (let hour = 0; hour < 24; hour += 1) {
        for (let minute = 0; minute < 60; minute += 5) {
          const value = `${this.pad(hour)}:${this.pad(minute)}`;
          const text = `${this.pad(hour)}H${this.pad(minute)}`;
          options.push({ value, text });
        }
      }
      if (
        this.customTimeOption &&
        !options.find((opt) => opt.value === this.customTimeOption)
      ) {
        options.push({
          value: this.customTimeOption,
          text: `${this.customTimeOption.replace(':', 'H')}`,
        });
      }
      return options.sort((a, b) => (a.value < b.value ? -1 : 1));
    },
  },
  watch: {
    menu(val) {
      if (val) {
        this.initialSnapshot = {
          date: this.selectedDate,
          time: this.selectedTime,
        };
        this.$nextTick(() => {
          this.scrollToSelected();
        });
      }
    },
    valField(val) {
      this.setFromValue(val);
    },
  },
  methods: {
    pad(value) {
      return String(value).padStart(2, '0');
    },
    buildNormalizedDate() {
      if (!this.selectedDate || !this.selectedTime) {
        return null;
      }
      const composed = `${this.selectedDate} ${this.selectedTime}:00`;
      const parsed = this.moment(
        composed,
        ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm'],
        true,
      );
      if (!parsed.isValid()) {
        return null;
      }
      return parsed.format('YYYY-MM-DD HH:mm:00');
    },
    updatePreview() {
      const normalized = this.buildNormalizedDate();
      this.pendingValue = normalized;
      if (this.selectedTime) {
        this.customTimeOption = this.selectedTime;
        this.highlightedTime = this.selectedTime;
      }
      if (normalized) {
        this.translateResult = this.moment(normalized)
          .locale('fr')
          .format('DD/MM/YYYY HH:mm');
      } else {
        this.translateResult = 'Choisir une date';
      }
      return normalized;
    },
    set() {
      const normalized = this.updatePreview();
      if (!normalized) {
        return;
      }
      this.model = normalized;
      if (typeof this.keyup === 'function') {
        this.keyup(this.item, normalized);
      }
      if (typeof this.change === 'function') {
        this.change(this.item, normalized);
      }
      this.changeStoreOnField({
        item: this.item,
        model: normalized,
        page: this.modalKey,
      });
      this.menu = false;
    },
    cancel() {
      this.selectedDate = this.initialSnapshot.date;
      this.selectedTime = this.initialSnapshot.time;
      this.customTimeOption = this.initialSnapshot.time;
      this.highlightedTime = this.initialSnapshot.time || '12:00';
      this.updatePreview();
      this.menu = false;
    },
    clearSelection() {
      this.selectedDate = null;
      this.selectedTime = null;
      this.customTimeOption = null;
      this.highlightedTime = '12:00';
      this.translateResult = 'Choisir une date';
      this.model = '0000-00-00 00:00:00';
      this.change(this.item, this.model);
      this.changeStoreOnField({
        item: this.item,
        model: this.model,
        page: this.modalKey,
      });
    },
    setFromValue(val) {
      if (!val || val === '0000-00-00 00:00:00') {
        this.selectedDate = null;
        this.selectedTime = null;
        this.customTimeOption = null;
        this.highlightedTime = '12:00';
        this.translateResult = 'Choisir une date';
        this.model = '0000-00-00 00:00:00';
        return;
      }
      const parsedStrict = this.moment(
        val,
        [
          'YYYY-MM-DD HH:mm:ss',
          'YYYY-MM-DD H:mm:ss',
          'YYYY-MM-DD HH:mm',
          'YYYY-MM-DD H:mm',
        ],
        true,
      );

      const parsed = parsedStrict.isValid()
        ? parsedStrict
        : this.moment(val);

      if (!parsed.isValid()) {
        return;
      }

      this.selectedDate = parsed.format('YYYY-MM-DD');
      this.selectedTime = parsed.format('HH:mm');
      this.customTimeOption = this.selectedTime;
      this.highlightedTime = this.selectedTime;
      this.model = parsed.format('YYYY-MM-DD HH:mm:00');
      this.translateResult = parsed.format('DD/MM/YYYY HH:mm');
      this.pendingValue = this.model;
      if (this.menu) {
        this.$nextTick(() => {
          this.scrollToSelected();
        });
      }
    },
    selectTime(value) {
      this.selectedTime = value;
      this.customTimeOption = value;
      this.highlightedTime = value;
      this.updatePreview();
      if (this.menu) {
        this.$nextTick(() => {
          this.scrollToSelected();
        });
      }
    },
    scrollToSelected(attempt = 0) {
      this.$nextTick(() => {
        const container = this.$refs.timeList;
        if (!container) {
          return;
        }

        const items = container.querySelectorAll('.time-select__item');
        const containerHeight = container.clientHeight;

        if (
          (items.length === 0 || containerHeight === 0) &&
          attempt < 5
        ) {
          setTimeout(() => this.scrollToSelected(attempt + 1), 40);
          return;
        }

        const targetValue =
          this.highlightedTime || this.selectedTime || '12:00';
        const index = this.timeOptions.findIndex(
          (opt) => opt.value === targetValue,
        );
        if (index < 0 || items.length === 0) {
          return;
        }

        const itemHeight = items[0].offsetHeight || 36;
        const offset = Math.max(
          index * itemHeight - containerHeight / 2 + itemHeight / 2,
          0,
        );

        requestAnimationFrame(() => {
          container.scrollTop = offset;
        });
      });
    },
  },
  mounted() {
    this.setFromValue(this.valField);
    this.updatePreview();
  },
};
</script>

<style scoped>
.v-card-text {
  max-width: 320px;
}

.time-select__label {
  font-size: 0.75rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 4px;
  text-transform: uppercase;
}

.time-select__list {
  max-height: 240px;
  overflow-y: auto;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}

.time-select__item {
  min-height: 36px;
  cursor: pointer;
}

.time-select__item--active {
  background-color: rgba(0, 0, 0, 0.08);
}

.time-select__item--active .v-list-item__title {
  font-weight: 600;
}
</style>
